import { useCallback } from 'react';

const useFileToBase64 = () => {
  const fileToBase64 = useCallback((file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }, []);

  const dataURLtoFile = (dataUrl, filename) => {
    if (!dataUrl || !dataUrl.startsWith('data:')) {
      throw new Error(`Invalid data URL: ${dataUrl}`);
    }

    const arr = dataUrl.split(',');
    // arr[0] = "data:image/png;base64"
    // arr[1] = "iVBORw0KGgoAAAANSUhEUgAAAyAAAAJYCAYAA..."
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch) {
      throw new Error(`Проблема с фото base64: ${arr[0]}`);
    }

    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
  };

  return {fileToBase64, dataURLtoFile};
};

export default useFileToBase64;
